module.exports = __webpack_public_path__ + "static/salt-harvesting-3060093_640-915762ffec015c921e46635f2979f0ef.jpg";